import { render, staticRenderFns } from "./ReviewCaseResultEdit.vue?vue&type=template&id=eb01a048&scoped=true"
import script from "./ReviewCaseResultEdit.vue?vue&type=script&lang=js"
export * from "./ReviewCaseResultEdit.vue?vue&type=script&lang=js"
import style0 from "./ReviewCaseResultEdit.vue?vue&type=style&index=0&id=eb01a048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb01a048",
  null
  
)

export default component.exports